// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".small-apps-login-reminder-container {\n    background: #222;\n    overflow-wrap: break-word;\n    width: 90%;\n    margin: auto;\n    margin-top: 0;\n    padding: 20px;\n    border-radius: 10px;\n  }\n\n  .small-apps-wallet-connect-btn {\n    background: #1f8febaa;\n    text-transform: none;\n    margin-top: 10px;\n    color: #fff;\n  }\n  ", ""]);
// Exports
module.exports = exports;
